import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, ComponentSync, LL_H_C, LL_V_L, SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend/index';
import { convertValueDBToUI, resolveValueDisplay, valueType_Enumerated, valueType_SubEnumerated, valueType_SubTime, valueType_Time } from '@app/hcs-shared/core';
import { arrayToMap, dbObjectToId, Filter, MUSTNeverHappenException } from '@nu-art/ts-common';
import { ICONS } from '@app/styles';
import { ModuleFE_Value } from '../../../../_entity.js';
export class SubTimeEditor extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        const allValues = ModuleFE_Value.cache.all();
        const valuesMap = arrayToMap(allValues, dbObjectToId);
        const parentId = nextProps.value.data?.parent._id;
        const parentValue = valuesMap[parentId];
        if (!parentValue)
            throw new MUSTNeverHappenException(`Could not find parent value with id ${parentId} for value with id ${nextProps.value._id}`);
        const scope = this.getValueScope(parentValue);
        state.allPossibleValues = scope.map(id => convertValueDBToUI(valuesMap[id], { values: valuesMap, measurementUnits: {} }));
        return state;
    }
    // ######################## Logic ########################
    getValueScope(value) {
        switch (value.type) {
            case valueType_SubEnumerated:
            case valueType_SubTime:
            case valueType_Enumerated:
                return value.data.scope;
            case valueType_Time:
                return value.data.timeRanges;
            default:
                return [];
        }
    }
    addExistingInnerValue = (innerValue) => {
        if (!innerValue)
            return;
        this.props.value.data.scope.push(innerValue);
        this.forceUpdate();
    };
    removeInnerValue = (innerValue) => {
        this.props.value.data.scope = this.props.value.data.scope.filter(item => item !== innerValue);
        this.forceUpdate();
    };
    // ######################## Render ########################
    render() {
        return _jsx("div", { className: 'sub-enumerated-editor', children: _jsx(LL_V_L, { className: 'dialog__main__section', children: this.renderValues() }) });
    }
    renderValues = () => {
        const values = this.props.value.data?.scope ?? [];
        // sortArray(values, value => value.data?.timeRange[0]);
        //Create dropdown props
        const valueIds = values.map(value => value._id);
        const possibleValues = this.state.allPossibleValues.filter(value => !valueIds.includes(value._id));
        const adapter = SimpleListAdapter(possibleValues, node => _jsx("div", { className: 'node-data', children: resolveValueDisplay(node.item) }));
        const filter = new Filter(item => [resolveValueDisplay(item)]);
        return _jsx(LL_V_L, { children: _jsxs(LL_H_C, { className: 'inner-values', children: [values.map(value => {
                        const className = _className('inner-value', value._id ? 'existing' : undefined);
                        return _jsxs("div", { className: className, children: [_jsx(Button, { onClick: () => this.removeInnerValue(value), children: _jsx(ICONS.x.component, {}) }), _jsx("span", { children: resolveValueDisplay(value) })] }, value._id);
                    }), _jsx(TS_DropDown, { adapter: adapter, selected: undefined, onSelected: this.addExistingInnerValue, filter: filter, tabIndex: 0, placeholder: 'Select Value', boundingParentSelector: '.dialog__main' })] }) });
    };
}
//# sourceMappingURL=SubTimeEditor.js.map